export class MathHelper {
  public static round2Decimals(amount: number) {
    return Math.round((amount + Number.EPSILON) * 100) / 100;
  }

  public static divideAndRound2(numerator: number, denominator: number, fallback = 0) {
    const result = MathHelper.divide(numerator, denominator, fallback);
    return MathHelper.round2Decimals(result);
  }

  // simply divides 2 numbers and avoids deviding by zero
  public static divide(numerator: number, denominator: number, fallback = 0): number {
    if (denominator !== 0) {
      return numerator / denominator;
    }
    return fallback;
  }

  // helper to make numbers floor at 0 Ex: -1=>0 and 1=>1
  public static zeroIfNegative(value: number) {
    if (value < 0) {
      return 0;
    }
    return value;
  }
}
